import { backendAPI } from '../../helper/apis';


export function updateDynamicPrice(params) {
  return backendAPI.put(`/v2/dynamicprice`, params);
}
